import { __spreadArray, __assign } from '../../node_modules/tslib/tslib.es6.js';
import React, { useState, useEffect } from 'react';
import './index.css.js';
import { Box, themeGet, Text, Spinner, Octicon } from '@primer/react';
import AlertIcon from '../../icons/alertIcon.js';
import CheckIcon from '../../icons/checkIcon.js';
import InfoIcon from '../../icons/infoIcon.js';
import NoEntryFillIcon from '../../icons/noEntryFillIcon.js';
import XIcon from '../../icons/XIcon.js';
import Timer from '../../icons/timer.js';
import LTTimer from '../LTTimer/index.js';
import LTIconButton from '../LTIconButton/index.js';
import LTButton from '../LTButton/index.js';
import { createUniqueID } from '../../utils/functions.js';
import { ToastContainer, BaseStyledToast, ToastBody, DefaultToast, LoadingToast, DangerToast, WarningToast, SuccessToast } from './styles.js';

var updatedDuration = 72000000;
var defaultDurationBeforeExtension = 20000;
var LTToastIcon = function LTToastIcon(_a) {
  var icon = _a.icon;
    _a.label;
  return /*#__PURE__*/React.createElement(Octicon, {
    "aria-hidden": true,
    icon: icon,
    size: 16,
    sx: {
      color: "fg.onEmphasis"
    }
  });
};
var LTToastComponent = function LTToastComponent(type) {
  switch (type) {
    case LTToast.ToastVariants.SUCCESS:
      return {
        icon: /*#__PURE__*/React.createElement(LTToastIcon, {
          icon: CheckIcon,
          label: "success icon"
        }),
        parentContainer: function parentContainer(_a) {
          var children = _a.children;
          return /*#__PURE__*/React.createElement(SuccessToast, null, children);
        }
      };
    case LTToast.ToastVariants.WARNING:
      return {
        icon: /*#__PURE__*/React.createElement(LTToastIcon, {
          icon: AlertIcon,
          label: "warning icon"
        }),
        parentContainer: function parentContainer(_a) {
          var children = _a.children;
          return /*#__PURE__*/React.createElement(WarningToast, null, children);
        }
      };
    case LTToast.ToastVariants.DANGER:
      return {
        icon: /*#__PURE__*/React.createElement(LTToastIcon, {
          icon: NoEntryFillIcon,
          label: "danger icon"
        }),
        parentContainer: function parentContainer(_a) {
          var children = _a.children;
          return /*#__PURE__*/React.createElement(DangerToast, null, children);
        }
      };
    case LTToast.ToastVariants.LOADING:
      return {
        icon: /*#__PURE__*/React.createElement(Spinner, {
          size: "small",
          sx: {
            color: "fg.onEmphasis"
          }
        }),
        parentContainer: function parentContainer(_a) {
          var children = _a.children;
          return /*#__PURE__*/React.createElement(LoadingToast, null, children);
        }
      };
    default:
      return {
        icon: /*#__PURE__*/React.createElement(LTToastIcon, {
          icon: InfoIcon,
          label: "info icon"
        }),
        parentContainer: function parentContainer(_a) {
          var children = _a.children;
          return /*#__PURE__*/React.createElement(DefaultToast, null, children);
        }
      };
  }
};
var LTToast = function LTToast(_a) {
  var _b = _a.sendNotification,
    sendNotification = _b === void 0 ? function () {} : _b;
  var _c = useState([]),
    toasts = _c[0],
    setToasts = _c[1];
  var _d = useState(null),
    addingToastId = _d[0],
    setAddingToastId = _d[1];
  var _e = useState(null),
    removingToastId = _e[0],
    setRemovingToastId = _e[1];
  var addToast = function addToast(newToast) {
    var _a = newToast || {},
      _b = _a.duration,
      duration = _b === void 0 ? 2000 : _b,
      _c = _a.extendDuration,
      extendDuration = _c === void 0 ? false : _c;
    var preventAutoClose = newToast.variant === LTToast.ToastVariants.LOADING;
    var defaultToastDuration = extendDuration ? defaultDurationBeforeExtension : duration;
    var startTime = Date.now(); // Start time of the new toast
    var toastId = createUniqueID("toast");
    newToast = __assign(__assign({}, newToast), {
      id: toastId,
      startTime: startTime,
      defaultToastDuration: defaultToastDuration,
      showTimer: true
    });
    setAddingToastId(toastId);
    var toastTimeOut;
    if (!preventAutoClose) {
      toastTimeOut = setTimeout(function () {
        removeToast(toastId);
      }, defaultToastDuration);
    }
    setToasts(function (prevToasts) {
      return __spreadArray(__spreadArray([], prevToasts, true), [__assign(__assign({}, newToast), {
        timeoutId: toastTimeOut
      })], false);
    });
    // timeout to remove fade-in effect class post addition of toast
    setTimeout(function () {
      setAddingToastId(null);
    }, 500);
    return toastId;
  };
  var removeToast = function removeToast(toastIdToRemove) {
    setRemovingToastId(toastIdToRemove); // Set the removing toast id
    // timeout for fading out effect
    setTimeout(function () {
      setToasts(function (prevToasts) {
        return prevToasts.filter(function (toast) {
          return (toast === null || toast === void 0 ? void 0 : toast.id) !== toastIdToRemove;
        });
      });
      setRemovingToastId(null); // Reset the removing toast id after the fade-out
    }, 500); // Adjust the timeout to match your CSS transition duration
  };

  var updateToast = function updateToast(toastId, config) {
    var updateToastState = function updateToastState(prevState) {
      var newToasts = prevState.map(function (toast) {
        if (toast.id === toastId) {
          var updatedToast = __assign(__assign(__assign({}, toast), config), {
            startTime: Date.now()
          });
          // clear removeToast timeout if it exists
          if (toast.timeoutId) {
            clearTimeout(toast.timeoutId);
          }
          if (config.variant !== LTToast.ToastVariants.LOADING) {
            // create a new timout to removeToast (except for loading toast)
            var duration = toast.extendDuration ? defaultDurationBeforeExtension : config.duration || toast.duration;
            updatedToast.timeoutId = setTimeout(function () {
              removeToast(toastId);
            }, duration);
          }
          return updatedToast;
        }
        return toast;
      });
      return newToasts;
    };
    setToasts(function (prevToasts) {
      return updateToastState(prevToasts);
    });
  };
  // to compute time left for toast to hide
  var getTimeLeft = function getTimeLeft(startTime, defaultToastDuration) {
    if (!startTime) {
      return defaultToastDuration; // If timeout hasn't started yet
    }

    var elapsedTime = Date.now() - startTime;
    var timeLeft = defaultToastDuration - elapsedTime;
    return timeLeft > 0 ? timeLeft : 0;
  };
  var increaseToastDuration = function increaseToastDuration(toast) {
    var _a = (toast || {}).timeoutId,
      timeoutId = _a === void 0 ? "" : _a;
    // Clear the previous timeout
    clearTimeout(timeoutId);
    // Increase the duration by 20 hours and remove the cta
    // Set a new timeout with the updated duration
    var toastTimeOut = setTimeout(function () {
      removeToast(toast === null || toast === void 0 ? void 0 : toast.id);
    }, updatedDuration);
    setToasts(function (prevToasts) {
      return prevToasts.map(function (t) {
        if ((t === null || t === void 0 ? void 0 : t.id) === (toast === null || toast === void 0 ? void 0 : toast.id)) {
          return __assign(__assign({}, t), {
            timerId: toastTimeOut,
            showTimer: false
          });
        }
        return t;
      });
    });
  };
  useEffect(function () {
    sendNotification(addToast, updateToast, removeToast);
  }, []);
  useEffect(function () {
    if (toasts.length === 0) {
      return;
    }
    // timeout of 500ms as toast takes 500ms to appear on UI
    // due to animation effect
    setTimeout(function () {
      var recentToastEl = document.getElementsByClassName("ltToast-0")[0];
      if (recentToastEl) {
        recentToastEl.focus();
      }
    }, 500);
  }, [toasts]);
  var toastCopy = __spreadArray([], toasts, true);
  return /*#__PURE__*/React.createElement(ToastContainer, {
    className: "lt-toast-container"
  }, toastCopy.reverse().map(function (toast, index) {
    var _a = toast || {},
      _b = _a.className,
      className = _b === void 0 ? "" : _b,
      _c = _a.defaultToastDuration,
      defaultToastDuration = _c === void 0 ? "" : _c,
      _d = _a.extendDuration,
      extendDuration = _d === void 0 ? false : _d,
      _e = _a.id,
      id = _e === void 0 ? "" : _e,
      locator = _a.locator,
      _f = _a.message,
      message = _f === void 0 ? "" : _f,
      _g = _a.showTimer,
      showTimer = _g === void 0 ? "" : _g,
      _h = _a.showCloseBtn,
      showCloseBtn = _h === void 0 ? false : _h,
      _j = _a.startTime,
      startTime = _j === void 0 ? "" : _j,
      _k = _a.variant,
      variant = _k === void 0 ? LTToast.ToastVariants.DEFAULT : _k;
    var preventAutoClose = variant === LTToast.ToastVariants.LOADING;
    var _l = LTToastComponent(variant),
      icon = _l.icon,
      ParentContainer = _l.parentContainer;
    return /*#__PURE__*/React.createElement(BaseStyledToast, {
      className: "ltToast--stacked ".concat(extendDuration && "ltToast-".concat(index), " ").concat(removingToastId === id ? "toast-fade-out" : "", " ").concat(addingToastId === id ? "toast-fade-in" : "", " ").concat(className),
      id: locator || id,
      role: "alert",
      tabIndex: extendDuration ? 0 : -1
    }, /*#__PURE__*/React.createElement(ParentContainer, null, /*#__PURE__*/React.createElement(Box, {
      sx: {
        padding: themeGet("space.3")
      }
    }, icon), /*#__PURE__*/React.createElement(ToastBody, null, /*#__PURE__*/React.createElement(Text, null, message), /*#__PURE__*/React.createElement(Box, {
      sx: {
        display: "flex",
        alignItems: "center",
        gap: "4px"
      }
    }, !preventAutoClose && extendDuration && showTimer && /*#__PURE__*/React.createElement(LTButton, {
      ariaLabel: "Click here to extend the toast duration",
      leadingIcon: /*#__PURE__*/React.createElement(Timer, null),
      onClick: function onClick() {
        return increaseToastDuration(toast);
      },
      size: LTButton.Size.MEDIUM,
      variant: LTButton.Variant.DEFAULT
    }, /*#__PURE__*/React.createElement(LTTimer, {
      "aria-hidden": true,
      style: {
        fontSize: "12px"
      },
      timeInMs: getTimeLeft(startTime, defaultToastDuration)
    })), !preventAutoClose && (showCloseBtn || extendDuration) && /*#__PURE__*/React.createElement(LTIconButton, {
      icon: XIcon,
      onClick: function onClick() {
        return removeToast(id);
      },
      variant: LTIconButton.IconButtonVariants.INVISIBLE,
      ariaLabel: "Close Toast"
    })))));
  }));
};
LTToast.ToastVariants = {
  DANGER: "danger",
  DEFAULT: "default",
  SUCCESS: "success",
  WARNING: "warning",
  LOADING: "loading"
};

export { LTToast as default };
